<template>
  <ChartWrapper class="pulse-chart" :status="status">
    <div class="container">
      <div class="line-chart">
        <svg class="root" ref="root" />
      </div>

      <div class="week-numbers-chart" :class="{'compare' : isCompareMode}">
        <transition-group tag="div" name="fade">
          <div class="week-item" :class="'w-'+i" v-for="(item, i) in weekNumbersChartData" :key="sector+'_'+item.x0" :style="{left: item.x0 + 'px', width: item.width + 'px'}">
            <div class="cell">
              <div class="number">{{item.value.toFixed(2)}}%</div>
              <div class="arrow" :class="{down: item.value < 0, up: item.value >= 0, blue: item.value >= 0}"></div>
            </div>
            <div class="cell cell-bottom" v-if="weekNumbersChartData2">
              <div class="number">{{weekNumbersChartData2[i].value.toFixed(2)}}%</div>
              <div class="arrow" :class="{down: weekNumbersChartData2[i].value < 0, up: weekNumbersChartData2[i].value >= 0, red: weekNumbersChartData2[i].value >= 0}"></div>
            </div>
          </div>
        </transition-group>

      </div>
    </div>
  </ChartWrapper>
</template>

<script>
import d3 from '@/utils/d3_importer'
import localeObj from '@/assets/d3-time-format-locale/es-ES'
import ChartWrapper from '@/components/IndicatorCards/parts/charts/ChartWrapper'

var moment = require('moment');
// import * as data from '@/assets/fake_data/evol_tourism_ranking.json'
export default {
  name: "PulseChart",
  components:{
    ChartWrapper
  },
  props:{
    data: {
      type: Object
    },
    compareData: {
      required: false
    },
    status: Object,
    sector: String
  },
  data () {
    return {
    //   margin: {left: 23, top: 10, right: 23, bottom: 20},
      xScale: d3.scaleTime()
    }
  },
  mounted () {
    this.drawChart()

  },
  computed: {
    lineChartData () {
      //find id === "evol_pulse" i dspres find id === "evol_pulse_days" i passar-ho com a arr
      let evolPulseData = this.data && this.data.data.find(el => {  return el.id === "evol_pulse"})
      let evolPulseDays = this.data && [evolPulseData.data.find(el => {  return el.id === "evol_pulse_days"})]
      return evolPulseDays
    },
    lineChartData2 () {
      if(this.compareData){
        let evolPulseData = this.compareData && this.compareData.data.find(el => {  return el.id === "evol_pulse"})
        let evolPulseDays = this.compareData && [evolPulseData.data.find(el => {  return el.id === "evol_pulse_days"})]
        return evolPulseDays
      } else {
        return null
      }
    },
    allDates () {
      if(this.lineChartData) {
        return this.lineChartData[0].data.map(d => {return d.valueDate})
      } else {
        return null
      }
    },
    weekDates () {
      if(this.lineChartData) {
        return this.allDates.filter(function(value, index) { return index % 7 === 0 })
      } else {
        return null
      }
    },
    // weekDatesOnScale () {
    //   if(this.lineChartData) {
    //     return this.weekDates.map(w => { return {valueDate: w, onAxis: this.xScale(w)}})
    //   } else {
    //     return null
    //   }
    // },
    weekNumbersChartData () {
      // let caca = this.xScale
      if(this.lineChartData) {
        return this.computeWeekDatas(this.data)
      } else {
        return null
      }
    },
    weekNumbersChartData2 () {
      // let caca = this.xScale
      if(this.lineChartData2) {
        return this.computeWeekDatas(this.compareData)
      } else {
        return null
      }
    }
  },
  watch: {
    data () {
      this.drawChart()
    },
    compareData () {
      this.drawChart()
    }
    // selectedItem () {
    //   console.log(this.selectedItem)
    //   this.drawChart()
    // }
  },
  methods: {
    
    computeWeekDatas (data){
      let evolPulseData = data && data.data.find(el => {  return el.id === "evol_pulse"})
      let evolPulseWeek = data && evolPulseData.data.find(el => {  return el.id === "evol_pulse_weeks"})
      let weekDatesOnScale = this.weekDates.map(w => { return {valueDate: w, onAxis: this.xScale(w)}})
      let weekNumbersChartData = this.weekDates.map((d, i) => {
        if(i != (weekDatesOnScale.length -1)) {
          let x0 = this.xScale(d)
          let xF = this.xScale(this.weekDates[i + 1])
          return  {x0, xF, width: xF-x0, valueDate0: d, valueDateF: weekDatesOnScale[i + 1], value: evolPulseWeek.data[i].value}
        } else { return }
      })
      return weekNumbersChartData.slice(0,weekNumbersChartData.length-1)
    },
    //closestStart to a util maybe??
    closestStart (date, startOfStr = 'month') {
      let prev = moment(date).startOf(startOfStr)
      let next = (moment(date).startOf(startOfStr).add(1, startOfStr))
      let closest = prev
      if( date - prev > next - date )
        closest = next
      return closest
    },
    drawChart () {
      if(!this.lineChartData) return
      // "consts"
      
      let linesData = this.lineChartData.concat(this.lineChartData2||[])
      
      let height = this.$refs.root.clientHeight
      let width = this.$refs.root.clientWidth
      let margin= {left: 7*width/100, top: 2, right: 7*width/100, bottom: 25}

      let yMax = d3.max(linesData.map(d => {return d3.max(d.data, dd => dd.value)}))
      let y = d3.scaleLinear().domain([0,1.1*yMax]).range([height-margin.bottom,margin.top])  // d3.max(this.lineChartData, function(d) { return +d.value; })

      // let yAxis = d3.axisLeft(y).ticks(0) // tickFormat(d3.format(".0%")).ticks(8)

      let locale = d3.timeFormatDefaultLocale(localeObj)
      //nomes tenim en compte el domain x de la primera linia de dades...
      // let this.allDates = this.lineChartData[0].data.map(d => {return d.valueDate})

      let mi = this.closestStart(Math.min(...this.allDates), 'day')
      let ma = this.closestStart(Math.max(...this.allDates), 'day')
      this.xScale = d3.scaleTime().domain([mi,ma]).range([margin.left,width-margin.right])
      let format = locale.format("%d/%m/%y")
      let xAxis = d3.axisBottom(this.xScale).tickValues(this.allDates).tickFormat(function (d, i) { if(i % 7 === 0){return format(d)} return ''})
      // root and axis
      let root = d3.select(this.$refs.root)
      let xAxisSelection = root.selectAll('.x-axis').data([null])
      let xAxisSelectionEnter = xAxisSelection.enter().append('g').attr('class','x-axis').attr("transform", `translate(0,${height - margin.bottom})`)
      xAxisSelection = xAxisSelection.merge(xAxisSelectionEnter)
      xAxisSelection.call(xAxis)
      let isSunday = (d) => new Date(d).getDay()===0
      xAxisSelection.selectAll('.tick').classed('sunday',d => isSunday(d)).select('line').attr('y2',d => isSunday(d)?8:6)
      // let yAxisSelection = root.selectAll('.y-axis').data([null]).enter().append('g').attr('class','y-axis').attr("transform", `translate(${margin.left},0)`)
      // yAxisSelection.call(yAxis)

      // let this.weekDates = this.allDates.filter(function(value, index) { return index % 7 === 0 });
      root.selectAll('.x-grid').data([null]).enter().append('g').attr('class','x-grid')
        .attr("transform", `translate(0,${height - margin.bottom})`)
        .call(d3.axisBottom(this.xScale)
          .tickValues(this.weekDates)
          .tickSize(-height + margin.bottom + margin.top)
          .tickFormat("")
        )

      // actual content
      let line = d3.line()
        .curve(d3.curveCardinal.tension(0.7))
        .defined(d => !isNaN(d.value))
        .x((d) => {
          // console.log("d",d)
          return this.xScale(d.valueDate)
        })
        .y((d) => y(d.value))


      function transition(sel) {
        sel.transition()
          .duration(2000)
          .ease(d3.easeLinear)
          .attrTween("stroke-dasharray", tweenDash)

      }
      function tweenDash() {
        var l = this.getTotalLength(),
            i = d3.interpolateString("0," + l, l + "," + l);
        return function(t) { return i(t); };
      }
      
      
      let currentSector = this.sector
      let items = root.selectAll('.item')
        .data(linesData, (d) => Math.random()) //BASTATNE FEO ESTO, pero era dificil "anotar" el currentSectore en el data...
      let itemsEnter = items.enter().append('g')
        .attr('class', (d,i)=>'item'+(i===1?' compared':''))
      itemsEnter
        // .append('title')
        .append("path")
        .style("mix-blend-mode", null)
        .attr("fill", "none")
        .attr("stroke-width", 2.5)
        .attr("d", (d)=>line(d.data))
        .call(transition);
      items.exit().remove()
      // items = items.merge(itemsEnter)
      // items.select('path').attr("d", (d)=>{
      //   return line(d.data)
      // })
    }
  }
}
</script>

<style scoped lang="stylus">
.pulse-chart
  display: flex;
  flex 1 1 auto
 
.container
  display: flex
  flex 1 1 auto
  flex-direction: column
  .line-chart
    // height: vh(130px)
    flex: 1 1 vh(130px)
    width: 100%
    .root
      height: 100%
      width: 100%

      >>> .x-axis
        .tick
          text-transform: uppercase
          &.sunday
            line 
              stroke #d20
              stroke-width 2px
          text
            color $bs-blue
            font-family: Lato
            m-font-size(11,13)
            .mobile &
              m-font-size(9,11)


      >>> .x-grid
        .domain
          display: none

        .tick
          opacity: 1

          line
            shape-rendering: crispEdges

      >>> .item
        path
          stroke: $bs-blue
        &.compared
          path
            stroke $compare-color
  .week-numbers-chart
    position: relative
    height: vh(60px)
    flex: 1 1 auto
    margin-top: 10px;
    width: 100%
    &.compare
      height: vh(90px)

    .week-item
      position absolute
      top: 0px
      height: 100%
      border-right: 1px solid black
      text-align: center
      display: flex
      flex-direction: column
      justify-content: center;
      font-family: Georgia
      m-font-size(15,17)
      // .cell
      //   border solid 1px #ddd

      &:last-child
        border none
        &:after
          content ''
          width 0
          height vh(30px)
          border-right: 1px solid black
          position absolute
          right 0
          top 0
      
      &:first-child
        &:after
          content ''
          width 0
          height vh(30px)
          border-right: 1px solid black
          position absolute
          left 0
          top 0
          .compare &.
            height 25%
      &.fade-enter-active
        transition opacity .3s
        &.w-0
          transition-delay .25s
        &.w-1
          transition-delay .75s
        &.w-2
          transition-delay 1.25s
        &.w-3
          transition-delay 1.75s
        // overflow hidden
      &.fade-leave-active
        transition opacity .1s
        transition-delay 0s

      &.fade-enter, &.fade-leave-to
        opacity 0
      .cell-bottom
        border-top 1px solid black
      .number
        m-font-size(14, 15)
        margin-bottom: vh(4px)
        margin-top: vh(4px)
      .arrow
        margin: vw(10px) auto

        &.up
          border-bottom: vw(10px) solid #555
          border-left: vw(8px) solid transparent
          border-right: vw(8px) solid transparent
          height: 0
          width: 0

        &.down
          border-left: vw(8px) solid transparent
          border-right: vw(8px) solid transparent
          border-top: vw(10px) solid #555
          height: 0
          width: 0

        &.blue
          border-bottom-color: $bs-blue
          border-top-color: $bs-blue
        &.red
          border-bottom-color: $compare-color
          border-top-color: $compare-color

</style>